import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environemnts/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PilotSchoolsService {

  //Created educator
  createdEducators: boolean = false;

  //Observables
  private schoolsData = new Subject<any>();
  schoolsData$ = this.schoolsData.asObservable();
  private newSchool = new Subject<any>();
  newSchool$ = this.newSchool.asObservable();
  private editedSchool = new Subject<any>();
  editedSchool$ = this.editedSchool.asObservable();
  private removedSchool = new Subject<any>();
  removedSchool$ = this.removedSchool.asObservable();
  private pilotSummary = new Subject<any>();
  pilotSummary$ = this.pilotSummary.asObservable();
  private schoolSummary = new Subject<any>();
  schoolSummary$ = this.schoolSummary.asObservable();
  private schoolCompleteData = new Subject<any>();
  schoolCompleteData$ = this.schoolCompleteData.asObservable();
  private selectedSchoolEducatorsDataSummary = new Subject<any>();
  selectedSchoolEducatorsDataSummary$ = this.selectedSchoolEducatorsDataSummary.asObservable();
  private selectedSchoolClasses = new Subject<any>();
  selectedSchoolClasses$ = this.selectedSchoolClasses.asObservable();
  
  constructor(private httpClient: HttpClient, private authService: AuthService) { }


  /**
   * Method to obtain school data
   * @param schoolId 
   */
  getSchoolCompleteData(schoolId: number) {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.get(environment.baseUrl+'/SchoolProfile/'+schoolId, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.schoolCompleteData.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.schoolCompleteData.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getSchoolCompleteData() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

  /**
   * Method to obtain school data
   * @param schoolId 
   */
  getSchoolCompleteDataObservable(schoolId: number) {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

   return this.httpClient.get(environment.baseUrl+'/SchoolProfile/'+schoolId, headers);

  }


    /**
   * Method to obtain all school data
   */
  getAllSchoolsDataObservable() {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

   return this.httpClient.get(environment.baseUrl+'/SchoolProfile/', headers);

  }

  /**
   * Get pilot schools
   */
  getSchoolsSummary() {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.get(environment.baseUrl+'/PilotSchoolOverview', headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      for(let i=0;i<datos.length;i++) {
        datos[i].country = this.authService.pilot;
      }

      //Order from recent to old
      datos = datos.sort((a: any, b: any) => 
        new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()
      );

      this.schoolsData.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.schoolsData.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getSchoolsSummary() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })


    // this.getJSON("./assets/fakeData/pilotSchoolsSummary.json")
    //   .subscribe(
    //     data => {
    //       let datos = data.data;
    //       console.log("GET SCHOOLS SUMMARY :", datos)
    //       this.schoolsData.next(datos);
    //     })
    }

   /**
   * Create a new school
   */
   createSchool(school: Object) {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    let body = school;

    this.httpClient.post(environment.baseUrl+'/SchoolProfile', body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.newSchool.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.newSchool.next(`error${error.status},${error.message}`);
      throw new Error(`Error in createSchool() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

  /**
   * Method to edit school data
   * @param school 
   */
  editSchoolData(id: number, school: any) {

    console.log("SCHOOL DATA :",school)

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    let body = school;

    this.httpClient.patch(environment.baseUrl+'/SchoolProfile/'+id, body, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.editedSchool.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.editedSchool.next(`error${error.status},${error.message}`);
      throw new Error(`Error in editSchoolData() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })
  }


  /**
   * Method to remove school
   * @param school 
   */
  removeSchool(id: number) {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }


    this.httpClient.delete(environment.baseUrl+'/SchoolProfile/'+id, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.removedSchool.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.removedSchool.next(`error${error.status},${error.message}`);
      throw new Error(`Error in removeSchool() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })
  }


  /**
   * Get a summary of the pilot
   */
  getPilotSummary() {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.get(environment.baseUrl+'/PilotOverview', headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));
      this.pilotSummary.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.pilotSummary.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getPilotSummary() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

   /**
   * Get a summary of the school
   */
   getSchoolSummary(school: number) {

    let headers = {
      headers: new HttpHeaders()
      .set('X-Pasiphae-Auth', this.authService.sessionToken)
      .set('X-Pilot-Code', this.authService.pilot)
      .set('X-User-Role', this.authService.role)
      .set('X-User-Id', String(this.authService.uuid))
    }

    this.httpClient.get(environment.baseUrl+'/SchoolOverview/'+school, headers).subscribe((data: any) => {

      let datos = JSON.parse(JSON.stringify(data));

      this.schoolSummary.next(datos);

    }, error => {
      console.log("Error :", JSON.parse(JSON.stringify(error)));
      this.schoolSummary.next(`error${error.status},${error.message}`);
      throw new Error(`Error in getSchoolSummary() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
    })

  }

    /**
     * Get a summary of the selected school data (educators,....)
     * @param school 
     */
    getSelectedSchoolEducatorsDataSummary(school: number) {

      let headers = {
        headers: new HttpHeaders()
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
      }
  
      this.httpClient.get(environment.baseUrl+'/School/'+school+'/educators', headers).subscribe((data: any) => {

        try {

          let datos = JSON.parse(JSON.stringify(data));

        //Order from recent to old
        datos = datos.sort((a: any, b: any) => 
          new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime()
        );

        //Count number of classes
        datos = datos.map((obj: any) => ({
          ...obj, classes: obj.classId.length
        }));
  
        this.selectedSchoolEducatorsDataSummary.next(datos);

        } catch (error : any){

          console.log("Error :", error, JSON.parse(JSON.stringify(error)));
          this.selectedSchoolEducatorsDataSummary.next(`error500,${error.message}`);
          throw new Error(`Error in getSelectedSchoolEducatorsDataSummary() method while processing with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);

        }
  
      }, error => {
        console.log("Error :", error, JSON.parse(JSON.stringify(error)));
        this.selectedSchoolEducatorsDataSummary.next(`error${error.status},${error.message}`);
        throw new Error(`Error in getSelectedSchoolEducatorsDataSummary() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
      })

    }

    /**
     * Get a summary of the selected school data
     * @param school 
     */
    getSelectedSchoolClassesData(school: number) {

      let headers = {
        headers: new HttpHeaders()
        .set('Content-Type','application/json')
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
      }
  
      this.httpClient.get(environment.baseUrl+'/School/'+school+"/classes", headers).subscribe((data: any) => {
 
        let datos = JSON.parse(JSON.stringify(data));

        //Order from recent to old
        datos = datos.sort((a: any, b: any) => 
          new Date(b.registrationDate).getTime() - new Date(a.registrationDate).getTime()
        );

        this.selectedSchoolClasses.next(datos);
  
      }, error => {
        console.log("Error :", JSON.parse(JSON.stringify(error)));
        this.selectedSchoolClasses.next(`error${error.status},${error.message}`);
        throw new Error(`Error in getSelectedSchoolClassesData() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);
      })
    
    }

       /**
     * Get a summary of the selected school data
     * @param school 
     */
    getSelectedSchoolClassesObservable(school: number) {

      let headers = {
        headers: new HttpHeaders()
        .set('Content-Type','application/json')
        .set('X-Pasiphae-Auth', this.authService.sessionToken)
        .set('X-Pilot-Code', this.authService.pilot)
        .set('X-User-Role', this.authService.role)
        .set('X-User-Id', String(this.authService.uuid))
      }
  
      return this.httpClient.get(environment.baseUrl+'/School/'+school+"/classes", headers);
    
    }




  /**
   * Method to read JSON file
   * @param location 
   * @returns 
   */
  getJSON(location: string): Observable<any> {
    return this.httpClient.get(location);
  }



}
